import { render } from "./AppConfirmationDialog.vue?vue&type=template&id=e877e464"
import script from "./AppConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./AppConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__